const { getMethod } = require('../common/api');

const validatePrivateListingPasscode = async (params) => {
  return getMethod('/api/private-listings/passcode/validate', params);
};

export default validatePrivateListingPasscode;
